<script lang="ts">
  interface Props {
    param: any;
    index: number;
    onclick?: (e: MouseEvent) => void;
    children?: import('svelte').Snippet;
  }

  let { param, index, onclick, children }: Props = $props();
</script>

<button
  data-cy="{param.label}-btn"
  type="button"
  class={index === 0 ? 'param-li' : 'param-label-li'}
  {onclick}
>
  {@render children?.()}
  <div class="text">{param.label}</div>
</button>

<style>
  .param-li {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    position: relative;
    padding-left: 16px;
    color: var(--blue);
    margin-bottom: 4px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  .param-label-li {
    display: inline-flex;
    flex-direction: row;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    position: relative;
    padding-left: 6px;
    color: var(--blue);
    margin-bottom: 4px;
    align-items: flex-start;
  }
  .param-li::before {
    content: '';
    width: 5px;
    height: 5px;
    background-color: var(--blue);
    border-radius: 50%;
    position: absolute;
    top: 8px;
    left: 0;
  }
</style>
